import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, Typography, Fade } from "@mui/material";

const EMPLoader = ({ loadingMessage }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    return () => setIsVisible(false);
  }, []);

  return (
    <Fade in={isVisible} timeout={300}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "40px",
          opacity: isVisible ? 1 : 0,
        }}
      >
        <Box sx={{ mr: 2 }}>
          <CircularProgress size={22} />
        </Box>
        <Box>
          <Typography variant="button" align="center">
            {loadingMessage}
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
};

EMPLoader.propTypes = {
  loadingMessage: PropTypes.node,
};

export default EMPLoader;
